import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.984 14.621c.082-.273.22-.547.383-.766v-.027h.028c.054-.082.136-.164.19-.219l8.313-8.312a1.766 1.766 0 0 1 2.489 0l1.066 1.066c.082.082.164.192.219.274a1.745 1.745 0 0 1-.219 2.215l-8.312 8.312c-.028.027-.082.055-.11.11-.027.027-.082.054-.11.081v.028h-.026c-.22.164-.493.3-.766.383l-2.133.629-1.176.355a.62.62 0 0 1-.629-.191.56.56 0 0 1-.164-.63l.328-1.175zm9.489-4.648-1.696-1.696-5.086 5.086.329 1.367 1.367.329zm-7.82 4.593-.329.22c-.027.054-.054.136-.082.218l-.191.629-.438 1.504 1.504-.438.63-.191c.081-.027.163-.055.218-.082l.219-.301-.848-.219a.65.65 0 0 1-.492-.492zm5.96-3.828-2.625 2.625a.463.463 0 0 1-.629 0 .43.43 0 0 1 0-.601l2.625-2.625a.416.416 0 0 1 .63 0 .43.43 0 0 1 0 .601"
    }, null, -1)
  ]))]))
}
export default { render: render }